var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.723,
    fill: "#637381",
    rx: 6.957
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.05 15.495h1.43v-2.488a19 19 0 0 0-2.083-.11c-2.06 0-3.471 1.295-3.471 3.677v2.192h-2.274v2.782h2.274v7h2.787v-7h2.182l.346-2.781h-2.529V16.85c.001-.804.218-1.355 1.338-1.355"
  })));
};
export default SvgFacebook;